var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.appLoading)?_c('story-viewer',{staticClass:"story-selector",attrs:{"story-name":_vm.name,"pages":_vm.pages}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }